import React from 'react'
import { Path } from 'react-native-svg'

import { genIcon } from './helper/gen'

const IconVolumeOutline = genIcon({
  size: 'small',
  render: color => {
    return (
      <Path
        fillRule="evenodd"
        fill={color}
        d="M8.222 1.333c.491 0 .89.28.89.625v12.084c0 .345-.399.625-.89.625L4.667 12H1.556c-.369 0-.667-.269-.667-.6V4.6c0-.331.298-.6.667-.6h3.11l3.556-2.667zm-.047 1.095l-3.508 2.46h-2.89v6.223h2.89l3.508 2.461V2.428zm4.534.408c.125 0 .238.052.32.135A7.089 7.089 0 0 1 15.11 8a7.089 7.089 0 0 1-2.083 5.028.444.444 0 0 1-.661-.597l.048-.049.179-.185A6.2 6.2 0 0 0 14.222 8 6.203 6.203 0 0 0 12.4 3.6a.446.446 0 0 1 .309-.764zm-1.868 1.9c.141 0 .267.066.349.17l-.047-.049A4.43 4.43 0 0 1 12.444 8a4.43 4.43 0 0 1-1.277 3.118.445.445 0 1 1-.651-.603h-.002A3.544 3.544 0 0 0 11.556 8c0-.982-.398-1.87-1.042-2.514a.458.458 0 0 1-.118-.306c0-.245.2-.444.445-.444z"
      />
    )
  },
})

export default IconVolumeOutline
